import { MeasurementFieldTypes } from '../../types/MeasurementFieldTypes';
import { SyncEngineHelpers } from 'helpers/SyncEngineHelpers';
import { FilterFunction } from './getFilterFunction';

const getSectionProgress = (values: object, filter: FilterFunction = () => true) => {
    const filteredFields = Object.entries(SyncEngineHelpers.crush(values))
        .filter(([name, value]) => filter(name, value, values))
        .filter(([key]) => !shouldIgnoreField(key));

    let totalFields = 0;
    let nonBlankFields = 0;
    const measurementFields: Record<string, unknown[]> = {};

    for (const [key, value] of filteredFields) {
        const measurementFieldPrefix = getMeasurementFieldPrefix(key);

        if (measurementFieldPrefix) {
            if (!(measurementFieldPrefix in measurementFields)) {
                measurementFields[measurementFieldPrefix] = [value];
            } else {
                measurementFields[measurementFieldPrefix].push(value);
            }
        } else {
            totalFields++;

            if (valueIsNotBlank(value)) {
                nonBlankFields++;
            }
        }
    }

    const [additionalFields, additionalNonBlankFields] = getMeasurementFieldCounts(measurementFields);
    totalFields += additionalFields;
    nonBlankFields += additionalNonBlankFields;

    return totalFields === 0 ? 100 : (nonBlankFields / totalFields) * 100;
};

const getMeasurementFieldPrefix = (key: string) => {
    const suffix = MeasurementFieldTypes.find((fieldType) => key.endsWith(`.${fieldType}`));
    return suffix ? key.slice(0, (suffix.length + 1) * -1) : null;
};

const shouldIgnoreField = (key: string) => key.includes('unit') || key.includes('enabled');

const valueIsNotBlank = (value: unknown) =>
    Array.isArray(value)
        ? value.length !== 0
        : Boolean(value) || (typeof value === 'number' && value.toString() === '0');

const getMeasurementFieldCounts = (measurementFields: Record<string, unknown[]>): [number, number] =>
    Object.values(measurementFields).reduce<[number, number]>(
        ([totalFields, nonBlankFields], fieldValues) => [
            totalFields + fieldValues.length,
            fieldValues.some(valueIsNotBlank) ? nonBlankFields + fieldValues.length : nonBlankFields,
        ],
        [0, 0],
    );

export { getSectionProgress };
